var firstPixel              = require('./core/core.js');
// var sliderHome              = require('./slider/home.js');
var sliderHomeActu          = require('./slider/sliderHomeActu.js');
var sliderStory             = require('./slider/story.js');
var shopCategory            = require('./functions/shopCategory.js');
var category                = require('./functions/category.js');
var productTabs             = require('./functions/productTabs.js');
var sliderIngredients       = require('./slider/allIngredients.js');
var home_thumbnail          = require('./slider/home_thumbnail.js');
var menuResponsiveAccordion = require('./functions/menuResponsiveAccordion.js');
var header                  = require('./functions/header.js');
var processus               = require('./functions/processus.js');
var quantity                = require('./functions/shop_quantity.js');
var values                  = require('./functions/values.js');
var popupGame               = require('./functions/popupGame.js');
var resizeBloc              = require('./functions/resizeBloc.js');
var newsletter              = require('./functions/newsletter.js');
var team                    = require('./functions/team.js');
var search                  = require('./functions/search.js');
var faqDeveloper            = require('./functions/faq.js');
var nousTrouver             = require('./functions/nousTrouver.js');
var shop                    = require('./functions/shop.js');
var popupNewsletter         = require('./functions/popupNewsletter.js');
// var sidebarScroll           = require('./functions/sidebarScroll.js');s

jQuery(document).ready(function ($) {
    firstPixel();
    $(document).ready(() => {
        $(document).foundation();
        nousTrouver();
    });
    shopCategory();

    // slider home
    home_thumbnail();
    // sliderHome();
    sliderStory();
    sliderIngredients();
    sliderHomeActu();
    header();
    menuResponsiveAccordion();

    team();
    category();
    productTabs();
    shopCategory();
    processus();
    quantity();
    values();
    popupGame();
    resizeBloc();
    newsletter();

    search();

    shop();
    popupNewsletter();
    // sidebarScroll();

    $(".woocommerce-cart article>h2:first-child()").html('<span class="bracket">' + $(".woocommerce-cart article>h2:first-child()").html() + '</span>');
    $(".woocommerce-checkout article>h2:first-child()").html('<span class="bracket">' + $(".woocommerce-checkout article>h2:first-child()").html() + '</span>');
});

// A tester
//jQuery.fn.load = function(callback){ $(window).on("load", callback) };
